import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SendSeparateChatMessagesDialogUsersQueryVariables = Types.Exact<{
  input: Types.UserSelectionInput;
}>;


export type SendSeparateChatMessagesDialogUsersQuery = { __typename?: 'Query', GetUsersForUserSelection: Array<{ __typename?: 'Employee', id: number, name: string }> };

export type SendSeparateChatMessagesMutationVariables = Types.Exact<{
  input: Types.SendSeparateChatMessagesInput;
}>;


export type SendSeparateChatMessagesMutation = { __typename?: 'Mutation', sendSeparateChatMessages: { __typename?: 'BaseMutationResult', success: boolean, error?: { __typename?: 'Error', code: string } | null } };


export const SendSeparateChatMessagesDialogUsersDocument = gql`
    query SendSeparateChatMessagesDialogUsers($input: UserSelectionInput!) {
  GetUsersForUserSelection(input: $input) {
    id
    name
  }
}
    `;

/**
 * __useSendSeparateChatMessagesDialogUsersQuery__
 *
 * To run a query within a React component, call `useSendSeparateChatMessagesDialogUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendSeparateChatMessagesDialogUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendSeparateChatMessagesDialogUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSeparateChatMessagesDialogUsersQuery(baseOptions: Apollo.QueryHookOptions<SendSeparateChatMessagesDialogUsersQuery, SendSeparateChatMessagesDialogUsersQueryVariables> & ({ variables: SendSeparateChatMessagesDialogUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendSeparateChatMessagesDialogUsersQuery, SendSeparateChatMessagesDialogUsersQueryVariables>(SendSeparateChatMessagesDialogUsersDocument, options);
      }
export function useSendSeparateChatMessagesDialogUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendSeparateChatMessagesDialogUsersQuery, SendSeparateChatMessagesDialogUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendSeparateChatMessagesDialogUsersQuery, SendSeparateChatMessagesDialogUsersQueryVariables>(SendSeparateChatMessagesDialogUsersDocument, options);
        }
export type SendSeparateChatMessagesDialogUsersQueryHookResult = ReturnType<typeof useSendSeparateChatMessagesDialogUsersQuery>;
export type SendSeparateChatMessagesDialogUsersLazyQueryHookResult = ReturnType<typeof useSendSeparateChatMessagesDialogUsersLazyQuery>;
export type SendSeparateChatMessagesDialogUsersQueryResult = Apollo.QueryResult<SendSeparateChatMessagesDialogUsersQuery, SendSeparateChatMessagesDialogUsersQueryVariables>;
export const SendSeparateChatMessagesDocument = gql`
    mutation SendSeparateChatMessages($input: SendSeparateChatMessagesInput!) {
  sendSeparateChatMessages(input: $input) {
    success
    error {
      code
    }
  }
}
    `;
export type SendSeparateChatMessagesMutationFn = Apollo.MutationFunction<SendSeparateChatMessagesMutation, SendSeparateChatMessagesMutationVariables>;

/**
 * __useSendSeparateChatMessagesMutation__
 *
 * To run a mutation, you first call `useSendSeparateChatMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSeparateChatMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSeparateChatMessagesMutation, { data, loading, error }] = useSendSeparateChatMessagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSeparateChatMessagesMutation(baseOptions?: Apollo.MutationHookOptions<SendSeparateChatMessagesMutation, SendSeparateChatMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSeparateChatMessagesMutation, SendSeparateChatMessagesMutationVariables>(SendSeparateChatMessagesDocument, options);
      }
export type SendSeparateChatMessagesMutationHookResult = ReturnType<typeof useSendSeparateChatMessagesMutation>;
export type SendSeparateChatMessagesMutationResult = Apollo.MutationResult<SendSeparateChatMessagesMutation>;
export type SendSeparateChatMessagesMutationOptions = Apollo.BaseMutationOptions<SendSeparateChatMessagesMutation, SendSeparateChatMessagesMutationVariables>;